import HorizontalRule from "@tiptap/extension-horizontal-rule";

export const CustomHorizontalRule = HorizontalRule.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			color: {
				default: "#000000",
				parseHTML: (element: HTMLElement) => {
					return (
						element.getAttribute("data-color") ||
						element.style.borderColor ||
						"#000000"
					);
				},
			},
			width: {
				default: "100%",
				parseHTML: (element: HTMLElement) => {
					return (
						element.getAttribute("data-width") ||
						element.style.width ||
						"100%"
					);
				},
			},
			thickness: {
				default: "0.2px",
				parseHTML: (element: HTMLElement) => {
					return (
						element.getAttribute("data-thickness") ||
						element.style.borderWidth ||
						"0.2px"
					);
				},
			},
		};
	},

	parseHTML() {
		return [
			{
				tag: "hr",
				getAttrs: (node: HTMLElement) => {
					// Prioritize data attributes, then inline style
					const dataColor = node.getAttribute("data-color");
					const dataWidth = node.getAttribute("data-width");
					const dataThickness = node.getAttribute("data-thickness");

					return {
						color: dataColor || node.style.borderColor || "#000000",
						width: dataWidth || node.style.width || "100%",
						thickness:
							dataThickness || node.style.borderWidth || "0.2px",
					};
				},
			},
		];
	},

	renderHTML({ node }) {
		const color = node.attrs.color || "#000000";
		const width = node.attrs.width || "100%";
		const thickness = node.attrs.thickness || "0.2px";

		return [
			"hr",
			{
				"data-color": color,
				"data-width": width,
				"data-thickness": thickness,
				style: `border-color: ${color}; width: ${width}; border-width: ${thickness}; border-style: solid; margin: 0;`,
			},
		];
	},

	addCommands() {
		return {
			...this.parent?.(),
			setHorizontalRule:
				(attributes?: {
					color?: string;
					width?: string;
					thickness?: string;
				}) =>
				({ commands }) => {
					return commands.insertContent({
						type: this.name,
						attrs: {
							color: attributes?.color || "#000000",
							width: attributes?.width || "100%",
							thickness: attributes?.thickness || "0.2px",
						},
					});
				},
		};
	},
});
